<span #text [ngClass]="styling.ngClass">
    <ng-content>

    </ng-content>
</span>